import { useState } from 'react';
import { User } from 'phosphor-react';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { toast } from 'react-toastify';

function LoginForm({ onLogin }) {
  const [username, setUsername] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim()) return;

    setIsLoading(true);
    try {
      // First check if user exists
 
   
        // Create new user if doesn't exist
        await axios.post(`${API_BASE_URL}/update-user`, {
          username: username.trim(),
          displayName: username.trim(),
          avatar: 'person'
        });
      

      localStorage.setItem('username', username.trim());
      toast.success('Zalogowano pomyślnie!');
      onLogin();
    } catch (error) {
      console.error('Error during login:', error);
      toast.error('Wystąpił błąd podczas logowania');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="bg-gray-800 p-8 rounded-lg shadow-lg w-96 border border-gray-700">
        <div className="flex items-center gap-3 mb-6">
          <User size={32} className="text-blue-400" />
          <h2 className="text-2xl font-bold text-white">Logowanie</h2>
        </div>
        
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Podaj nazwę użytkownika"
            className="w-full p-3 bg-gray-700 border border-gray-600 rounded-lg mb-4 
              text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 
              focus:border-transparent outline-none"
            autoFocus
            disabled={isLoading}
          />
          <button 
            type="submit"
            className={`w-full bg-blue-600 text-white py-3 rounded-lg font-medium 
              transition-colors duration-200
              ${isLoading 
                ? 'opacity-70 cursor-not-allowed' 
                : 'hover:bg-blue-700 active:bg-blue-800'}`}
            disabled={isLoading}
          >
            {isLoading ? 'Logowanie...' : 'Zaloguj się'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;
